import { Observable } from 'rxjs';
import { SnEnvService } from '@insight/serenity-env';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { DaaSResp, DaaSPostResp } from '../../classes/models/DaasResponse';
import { ClientBillingBackupFileConfiguration, BackupFileColumn } from '../../classes/models/ClientBillingBackupFileConfiguration';
@Injectable({
  providedIn: 'root'
})

export class ClientBillingBackupFileConfigurationService
{
  constructor(private _httpService: HttpService, private _envService: SnEnvService){}

  getBackupFileConfigurations(continuationToken?: string): Observable<any>
  {
    let url = this._envService.get('api_url') + 'backupfileconfiguration';
    if (continuationToken)
    {
      url += '?continuationToken=' + encodeURIComponent(continuationToken);
    }
    return this._httpService.get<any>(url);
  }

  getClientBackupFileConfigByAviClientId(aviClientId: string, continuationToken?: string): Observable<DaaSResp<ClientBillingBackupFileConfiguration>>
  {
    let url = this._envService.get('api_url') + `backupfileconfiguration/aviId/${aviClientId}`;
    if (continuationToken)
    {
      url += '?continuationToken=' + encodeURIComponent(continuationToken);
    }
    return this._httpService.get<any>(url);
  }

  getDefaultBackupFileConfiguration(): Observable<Array<BackupFileColumn>>
  {
    let url = this._envService.get('api_url') + `backupfileconfiguration/defaultBackupFileConfiguration`;
    return this._httpService.get<any>(url);
  }

  PushClientBackUpConfiguration(data: ClientBillingBackupFileConfiguration): Observable<DaaSPostResp<ClientBillingBackupFileConfiguration>>
  {
    let url = this._envService.get('api_url') + `backupfileconfiguration`;
    return this._httpService.post<any>(url, data);
  }
}
